import { Box, Stack, Typography } from '@mui/material';
import { DealSummaryCardTypes } from 'modules/dealBuilder';
import { DEAL_SUMMARY_CARD_STYLES } from 'modules/dealBuilder/constants';

interface Props {
  label: string;
  value: string;
  caption?: string;
  type: DealSummaryCardTypes;
}

export const SummaryCard = ({ label, value, caption, type }: Props) => {
  const { bgcolor, borderColor, color } = DEAL_SUMMARY_CARD_STYLES[type];
  return (
    <Box flex={1} p={1.5} borderRadius={1} border={1} sx={{ bgcolor, borderColor }}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Stack direction="row" alignItems="baseline" gap={1}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ color }}>
          {value}
        </Typography>
        {caption && (
          <Typography variant="caption" color="text.secondary">
            {caption}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};
